const LANG_STORAGE_KEY = 'lang';
const DEFAULT_LANG = 'th';

export const getStoredLang = (): string => {
  return window.localStorage.getItem(LANG_STORAGE_KEY) || DEFAULT_LANG;
};

export const setStoredLang = (lang: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(LANG_STORAGE_KEY, lang);
};

export const getInitialLang = (search: string): string => {
  const queryLang = new URLSearchParams(search).get('lang');

  if (queryLang) {
    setStoredLang(queryLang);
    return queryLang;
  }

  return getStoredLang();
};